import MgpButton from "../../elements/MgpButton/MgpButton";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";


type MessageModalContentProps = {
    type: "success" | "danger" | "info" | "warning" | "general";
    message: string;
    closeAction?: () => void;
    isLongMessage?: boolean
  };
  
  
  
  export default function MessageModalContent({
    type, message, closeAction, isLongMessage
  }: MessageModalContentProps) {

    return (
            <div className="modale--main-width-entreprise p-lg m-y-xl bg-blanc ta-center">   
              <div className="mr-lg" style={{textAlign: "left"}}>
                <MgpMessage message={message} type={type} hasCloseBtn={false} isLongMessage={isLongMessage} />
              </div>       
              
              <div className="wrapper-cta-inline m-y-lg">
                <MgpButton color="bleu" size="small" onClick={closeAction} text="Fermer"/>
              </div>
            </div>
    );
  }